var Assignment = /** @class */ (function () {
    function Assignment() {
        this.dateAssigned = null;
        this.type = "Assessment";
        this.items = [];
    }
    Object.defineProperty(Assignment.prototype, "Id", {
        get: function () {
            return this.id;
        },
        set: function (v) {
            this.id = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Assignment.prototype, "DateAssigned", {
        get: function () {
            return this.dateAssigned;
        },
        set: function (v) {
            this.dateAssigned = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Assignment.prototype, "DateCompleted", {
        get: function () {
            return this.dateCompleted;
        },
        set: function (v) {
            this.dateCompleted = v;
        },
        enumerable: true,
        configurable: true
    });
    Assignment.prototype.setDateAssigned = function (time) {
        this.DateAssigned = new Date(time);
        return this.DateAssigned;
    };
    Object.defineProperty(Assignment.prototype, "IsComplete", {
        get: function () {
            return this.dateCompleted != null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Assignment.prototype, "Type", {
        get: function () {
            return this.type;
        },
        set: function (v) {
            this.type = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Assignment.prototype, "Items", {
        get: function () {
            return this.items;
        },
        set: function (v) {
            v = v || []; // make sure we always get an array here
            this.items = v;
        },
        enumerable: true,
        configurable: true
    });
    Assignment.prototype.hasItem = function (v) {
        if (!(v && v.Id)) {
            return false;
        }
        if (this.items.find(function (i) { return i.Id == v.Id; }) !== undefined) {
            return true;
        }
        return false;
    };
    Assignment.prototype.getTotalAssignments = function () {
        return this.items.length;
    };
    Assignment.prototype.getAssignmentsCompleted = function () {
        return this.items.filter(function (i) { return i.IsComplete; }).length;
    };
    Object.defineProperty(Assignment.prototype, "hasStarted", {
        get: function () {
            return this.getAssignmentsCompleted() > 0;
        },
        enumerable: true,
        configurable: true
    });
    Assignment.prototype.getNextAssignmentItemToComplete = function () {
        return this.items.find(function (i) { return !i.IsComplete; });
    };
    Assignment.prototype.markCompleted = function (assignment) {
        var item = this.items.find(function (i) { return i.Id == assignment.Id; });
        if (item) {
            item.DateCompleted = new Date();
        }
        if (this.Items.every(function (i) { return i.IsComplete; })) {
            this.DateCompleted = new Date();
        }
    };
    Assignment.prototype.getResultIds = function () {
        return this.Items.filter(function (i) { return i.IsComplete; }).map(function (i) { return i.ResultId; });
    };
    return Assignment;
}());
export { Assignment };



// WEBPACK FOOTER //
// ./src/app/shared/models/Assignment.ts.pre-build-optimizer.js